/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {number}
 */

export const PersonTypeEnum = {
  JP_INSTRUCTOR: 1000,
  ADULT_GUEST: 181,
  ORGANIZATION_CONTACT: 21,
  FRIEND: 22,
  JUNIOR_PARENT: 41,
  ADULT_MEMBER: 1,
  JUNIOR_MEMBER: 2,
  UAP_MEMBER: 3,
  ORGANIZATION: 4,
  EMERGENCY_CONTACT: 2000,
} as const;

export type PersonTypeEnum =
  (typeof PersonTypeEnum)[keyof typeof PersonTypeEnum];

export type PersonTypeEnumEnumType = typeof PersonTypeEnum;
export type PersonTypeEnumOptional = PersonTypeEnum;
export type PersonTypeEnumTrackedI = PersonTypeEnum;
export type PersonTypeEnumTracked = PersonTypeEnum;
export type PersonTypeEnumMetaI = EnumMetaType<
  PersonTypeEnumEnumType,
  PersonTypeEnum
>;
export const PersonTypeEnumMeta = typeMetaEnum<
  PersonTypeEnumEnumType,
  PersonTypeEnum
>("PersonTypeEnum", PersonTypeEnum);
export function transformDatesPersonTypeEnum(model: PersonTypeEnum) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
